import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Select from 'react-select';
import JwPagination from 'jw-react-pagination';
import Scrollchor from 'react-scrollchor';
import PreviewCard from '../../../UI/PreviewCard/PreviewCard';
import './NewsBody.css';
import './NewsBodyPrint.css';

class NewsBody extends Component {
    constructor(props) {
        super(props);
        //we keep the original data
        const news = this.props.news;
        //years of the news.
        const yearsFiltered = [
            ...new Set(
                this.props.news.map(item =>
                    moment.utc(item.publishedDate).year()
                )
            ),
        ];

        //order years DESC.
        yearsFiltered.sort().reverse();

        //We transform the array of years, into a structure to use with the react-select.
        const years = yearsFiltered.reduce(
            (a, b) => {
                return [ ...a, { value: b, label: b } ];
            },
            [ { label: 'VIEW ALL', value: '' } ]
        );

        this.state = {
            pageOfItems: [],
            years,
            news,
            selectedOption: '',
        };
    }

    onPaginationClick = () => {
        this.topRef.simulateClick();
    }

    onChangePage = (pageOfItems) => {
        this.setState({
            pageOfItems,
        });
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll(event) {
        let currScrollPos = parseInt(window.pageYOffset, 10);

        if (currScrollPos === 0) { // for IE11 bug
            window.scrollTo(0, sessionStorage.scrollPos);
        }
        else {
            sessionStorage.scrollPos = currScrollPos;
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (document.querySelector('.page-number.active a')){
            const currentPage = parseInt(document.querySelector('.page-number.active a').textContent, 10);

            if (prevProps.page !== currentPage) {
                this.props.currentPaginationPage(currentPage);
            }
            if (sessionStorage.scrollPos !== 0) {
                window.scrollTo(0, sessionStorage.scrollPos);
            }
        }
    }

    filterChanged = data => {
        const year = data.value;
        const initialItems = this.props.news;
        let parserItems = initialItems;

        if (year)
            parserItems = initialItems.filter(
                item =>
                    moment.utc(item.publishedDate).year() === parseInt(year, 10)
            );

        this.setState(() => ({
            news: parserItems,
            selectedOption: data,
        }));
    }

    render() {
        if (!this.state.news) return null;

        const customLabels = {
            previous: '\u276E',
            next: '\u276F',
        };

        const labels = (this.props.isDesktop) ? (
            this.state.news.length > 120 ? customLabels : false
        ) : (
            this.state.news.length > 60 ? customLabels : false
        );

        return (
            <section className="section news-body">
                <div className="container">
                    <div className="columns">
                        <div className="column is-10-tablet is-offset-1-tablet">
                            <div className="columns is-multiline news-list-head">
                                <div className="column is-12-mobile is-12-tablet is-9-desktop is-vertical-center">
                                    <div className="big-title border-left-yellow">
                                        READ ALL ABOUT US
                                    </div>
                                </div>
                                <div className="column is-9-mobile is-5-tablet is-3-desktop is-vertical-center">
                                    <Select
                                        instanceId="news-year-select"
                                        className="select-wrapper"
                                        classNamePrefix="react-select"
                                        placeholder="FILTER BY YEAR"
                                        name="filter-by-year"
                                        options={this.state.years}
                                        value={this.state.selectedOption}
                                        isSearchable={false}
                                        onChange={this.filterChanged}
                                    />
                                </div>
                            </div>
                            <div id="news-grid" className="columns is-multiline news-grid">
                                <Scrollchor ref={ref => this.topRef = ref} to="news-grid" disableHistory={true} animate={{ duration: 250, offset: -78 }} />
                                {this.state.pageOfItems.map((panel, i) => (
                                    <div key={i} className="column is-6-tablet is-4-desktop">
                                        <PreviewCard
                                            title={panel.title}
                                            backgroundImage={panel.thumbnail}
                                            buttonLink={`/news${panel.slug}`}
                                            buttonTitle="Read More"
                                        />
                                    </div>
                                ))}
                            </div>
                            <div className="pagination-click-wrapper" role="link" tabIndex="-1" onKeyUp={() => this.onPaginationClick()} onClick={() => this.onPaginationClick()}>
                                <JwPagination pageSize={12} items={this.state.news} onChangePage={this.onChangePage} labels={labels} initialPage={this.props.page} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
NewsBody.propTypes = {
    news: PropTypes.array,
    isDesktop: PropTypes.bool,
    page: PropTypes.number.isRequired,
    currentPaginationPage: PropTypes.func.isRequired,
};

export default NewsBody;
